import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import loadConfig from "../../../../Services/Api/ApiServices";
import { GetAllAcademicDegree, GetAllSU_ST_RPI_AcademicDegree } from "../../../../Redux/Reducers/Submitter/InformationAboutResearchers/AcademicDegreeDropdown";
import {
  GetOneInformationAboutResearchers,
  restValidateInformationAboutResearchers,
  ValidateInformationAboutResearchers,
} from "../../../../Redux/Reducers/Submitter/InformationAboutResearchers";
import axios from "axios";
import $ from "jquery";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import "./style.css";
import InputAHSF from "../../../../Components/InputAHSF";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import AttachmentASFH from "../../../../Components/AttachmentsAHSF";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
function AddEditInformationAboutResearcher(props) {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      DropDownAcademicDegree:
        state.DropDownAcademicDegree.DropDownAcademicDegree,
        DropDownSU_ST_RPI_AcademicDegree:
        state.DropDownAcademicDegree.DropDownSU_ST_RPI_AcademicDegree,
      OneInformationAboutResearchers:
        state.OneInformationAboutResearchers.OneInformationAboutResearchers,
      loadingOneInformationAboutResearchers:
        state.OneInformationAboutResearchers
          .loadingOneInformationAboutResearchers,
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
      InformationAboutResearchersValidate:
        state.OneInformationAboutResearchers
          .InformationAboutResearchersValidate,
    };
  });

  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );
  console.log(state.DropDownAcademicDegree, "drop");

  console.log(state.OneInformationAboutResearchers, "one");

  // List for Gender options (Male, Female)
  const MaleOrFemale = [
    { KeyText: "ذكر", KeyValue: true },
    { KeyText: "انثى", KeyValue: false },
  ];
  // Initializing state for Project Technical Team Members
  const [InformationAboutResearcherList, setInformationAboutResearcherList] =
    useState({
      informationAboutResearchersId:
        state.OneInformationAboutResearchers?.informationAboutResearchersId,
      fullName: state.OneInformationAboutResearchers?.fullName,
      workPlace: state.OneInformationAboutResearchers?.workPlace,
      email: state.OneInformationAboutResearchers?.email,
      phoneNumber: state.OneInformationAboutResearchers?.phoneNumber,
      gender: state.OneInformationAboutResearchers?.gender,
      major: state.OneInformationAboutResearchers?.major,
      academicDegreeId: state.OneInformationAboutResearchers?.academicDegreeId,
      roleInResearch: state.OneInformationAboutResearchers?.roleInResearch,
      natonalBaseResearcherNmber:
        state.OneInformationAboutResearchers?.natonalBaseResearcherNmber,

      cvDocumentAttachment:
        state.OneInformationAboutResearchers?.cvDocumentAttachment,
    });
  const [CVDocumentAttachment, setCVDocumentAttachment] = useState();
  const [fileChange, setFileChange] = useState(0);
  const [dataJsonObject, SetDataJsonObject] = useState();
  // Function to load configuration data
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);

  console.log(InformationAboutResearcherList.applicationInformationId, "idd");

  console.log(InformationAboutResearcherList, "asa");

  useEffect(() => {
    dispatch(GetAllSU_ST_RPI_AcademicDegree());
  }, []);

  const AddInfo = async () => {
    const validationList = await dispatch(
      ValidateInformationAboutResearchers({
        fullName: InformationAboutResearcherList.fullName,
        workPlace: InformationAboutResearcherList.workPlace,
        phoneNumber: InformationAboutResearcherList.phoneNumber,
        gender:
          InformationAboutResearcherList.gender === "true"
            ? true
            : InformationAboutResearcherList.gender === "false"
            ? false
            : null,
        email: InformationAboutResearcherList.email,
        major: InformationAboutResearcherList.major,
        academicDegreeId: InformationAboutResearcherList.academicDegreeId,
        roleInResearch: InformationAboutResearcherList.roleInResearch,
        natonalBaseResearcherNmber:
          InformationAboutResearcherList.natonalBaseResearcherNmber,
        cvDocumentAttachment:
          InformationAboutResearcherList.cvDocumentAttachment,
      })
    );
    if (validationList.payload.length === 0) {
      await axios
        .post(
          `${dataJsonObject.domainUrl}/api/InformationAboutResearchers/AddInformationAboutResearchers`,
          {
            fullName: InformationAboutResearcherList.fullName,
            workPlace: InformationAboutResearcherList.workPlace,
            phoneNumber: InformationAboutResearcherList.phoneNumber,
            email: InformationAboutResearcherList.email,
            gender:
              InformationAboutResearcherList.gender == "true" ? true : false,
            major: InformationAboutResearcherList.major,
            academicDegreeId: InformationAboutResearcherList.academicDegreeId,
            roleInResearch: InformationAboutResearcherList.roleInResearch,
            natonalBaseResearcherNmber:
              InformationAboutResearcherList.natonalBaseResearcherNmber,
            file: CVDocumentAttachment,
            fileName: "CVDocumentAttachment",

            cvDocumentAttachment:
              InformationAboutResearcherList.cvDocumentAttachment,

            applicationInformationId:
              InformationAboutResearcherList.applicationInformationId,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          //console.log(res);
          $(".close-btn").trigger("click"); // Close modal after successful submission

          Swal.fire({
            position: "center",
            icon: "success",
            title: "تم اضافة المعلومات بنجاح",
            showConfirmButton: false,
            timer: 1500,
            // width: "500px",
          });

          dispatch(setRefreshTable());
        })
        .catch((err) => {
          //console.log(err);
        });
    }
  };
  useEffect(() => {
    dispatch(restValidateInformationAboutResearchers()); // Reset validation state when component mounts
  }, []);
  // Function to update an existing Project Technical Team Member
  const UpdateInfo = async () => {
    const validationList = await dispatch(
      ValidateInformationAboutResearchers({
        fullName: InformationAboutResearcherList.fullName,
        workPlace: InformationAboutResearcherList.workPlace,
        phoneNumber: InformationAboutResearcherList.phoneNumber,
        gender:
          InformationAboutResearcherList.gender === "true" ||
          InformationAboutResearcherList.gender == true
            ? true
            : InformationAboutResearcherList.gender === "false" ||
              InformationAboutResearcherList.gender == false
            ? false
            : null,
        email: InformationAboutResearcherList.email,

        major: InformationAboutResearcherList.major,
        academicDegreeId: InformationAboutResearcherList.academicDegreeId,
        roleInResearch: InformationAboutResearcherList.roleInResearch,
        natonalBaseResearcherNmber:
          InformationAboutResearcherList.natonalBaseResearcherNmber,
        cvDocumentAttachment:
          InformationAboutResearcherList.cvDocumentAttachment,
        applicationInformationId:
          InformationAboutResearcherList.applicationInformationId,
      })
    );

    if (validationList.payload.length === 0) {
      await axios
        .post(
          `${dataJsonObject.domainUrl}/api/InformationAboutResearchers/UpdateInformationAboutResearchers`,
          {
            informationAboutResearchersId:
              InformationAboutResearcherList.informationAboutResearchersId,
            fullName: InformationAboutResearcherList.fullName,
            workPlace: InformationAboutResearcherList.workPlace,
            phoneNumber: InformationAboutResearcherList.phoneNumber,
            gender:
              InformationAboutResearcherList.gender === "true" ||
              InformationAboutResearcherList.gender == true
                ? true
                : InformationAboutResearcherList.gender === "false" ||
                  InformationAboutResearcherList.gender == false
                ? false
                : null,
            email: InformationAboutResearcherList.email,

            major: InformationAboutResearcherList.major,
            academicDegreeId: InformationAboutResearcherList.academicDegreeId,
            roleInResearch: InformationAboutResearcherList.roleInResearch,
            natonalBaseResearcherNmber:
              InformationAboutResearcherList.natonalBaseResearcherNmber,
            file: fileChange > 0 ? CVDocumentAttachment : null,
            fileName: fileChange > 0 ? "CVDocumentAttachment" : null,
            cvDocumentAttachment:
              InformationAboutResearcherList.cvDocumentAttachment,
            applicationInformationId:
              InformationAboutResearcherList.applicationInformationId,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          //console.log(res);
          $(".close-btn").trigger("click");
          Swal.fire({
            position: "center",
            icon: "success",
            title: "تم تعديل المعلومات بنجاح",
            showConfirmButton: false,
            timer: 1500,
            // width: "500px",
          });
          dispatch(setRefreshTable());
        })
        .catch((err) => {
          //console.log(err);
        });
    }
  };
  console.log(dataJsonObject, "fff");

  useEffect(() => {
    // Effect to fetch rojectTechnicalTeamMembers details if available

    if (props != null) {
      dispatch(
        GetOneInformationAboutResearchers(props.informationAboutResearchersId)
      );
    }
  }, [props.informationAboutResearchersId]);
  useEffect(() => {
    // Effect to set ProjectTech list based on fetched data or reset

    if (
      !state.loadingOneInformationAboutResearchers &&
      Object.keys(props).length != 0
    ) {
      setInformationAboutResearcherList({
        ...state.OneInformationAboutResearchers,
      });
    } else {
      setInformationAboutResearcherList({
        // informationAboutResearchersId:
        //   InformationAboutResearcherList.informationAboutResearchersId,
        fullName: null,
        workPlace: null,
        phoneNumber: null,
        gender: null,
        major: null,
        academicDegreeId: null,
        roleInResearch: null,
        natonalBaseResearcherNmber: null,
        email: null,
        cvDocumentAttachment: null,
        applicationInformationId:
          state.ApplicationInformation?.applicationInformationId,
      });
    }
  }, [state.OneInformationAboutResearchers]);
  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  console.log(InformationAboutResearcherList?.academicDegreeId, "dee");

  return (
    <>
      {!state.loadingOneInformationAboutResearchers ? (
        <>
          <div className="AddEdite">
            <InputAHSF
              fieldsName="FullName"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setInformationAboutResearcherList({
                  ...InformationAboutResearcherList,
                  fullName: e.target.value,
                });
              }}
              defaultValue={state.OneInformationAboutResearchers?.fullName}
              showValidationMessage={
                state.InformationAboutResearchersValidate
                  ? state.InformationAboutResearchersValidate.includes(
                      "FullName"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="WorkPlace"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setInformationAboutResearcherList({
                  ...InformationAboutResearcherList,
                  workPlace: e.target.value,
                });
              }}
              defaultValue={state.OneInformationAboutResearchers?.workPlace}
              showValidationMessage={
                state.InformationAboutResearchersValidate
                  ? state.InformationAboutResearchersValidate.includes(
                      "WorkPlace"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="PhoneNumber"
              show={true}
              type={"number"}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setInformationAboutResearcherList({
                  ...InformationAboutResearcherList,
                  phoneNumber: e.target.value,
                });
              }}
              defaultValue={state.OneInformationAboutResearchers?.phoneNumber}
              showValidationMessage={
                state.InformationAboutResearchersValidate
                  ? state.InformationAboutResearchersValidate.includes(
                      "PhoneNumber"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="Email"
              // type={"email"}
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setInformationAboutResearcherList({
                  ...InformationAboutResearcherList,
                  email: e.target.value,
                });
              }}
              defaultValue={state.OneInformationAboutResearchers?.email}
              showValidationMessage={
                state.InformationAboutResearchersValidate
                  ? state.InformationAboutResearchersValidate.includes("Email")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="Gender"
              show={true}
              disabled={shouldDisableFields}
              KeyText={"KeyText"}
              KeyValue={"KeyValue"}
              arrayOoptionList={MaleOrFemale}
              dropdownType={"normal"}
              onChange={(e) => {
                setInformationAboutResearcherList({
                  ...InformationAboutResearcherList,
                  gender: e.target.value,
                });
              }}
              defaultValue={InformationAboutResearcherList?.gender}
              showValidationMessage={
                state.InformationAboutResearchersValidate
                  ? state.InformationAboutResearchersValidate.includes("Gender")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="Major"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setInformationAboutResearcherList({
                  ...InformationAboutResearcherList,
                  major: e.target.value,
                });
              }}
              defaultValue={state.OneInformationAboutResearchers?.major}
              showValidationMessage={
                state.InformationAboutResearchersValidate
                  ? state.InformationAboutResearchersValidate.includes("Major")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <AllDropDownsAHSF
              fieldsName="AcademicDegree"
              show={true}
              disabled={shouldDisableFields}
              arrayOoptionList={state.DropDownSU_ST_RPI_AcademicDegree}
              KeyText={"aademicDegreeName"}
              KeyValue={"academicDegreeId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setInformationAboutResearcherList({
                  ...InformationAboutResearcherList,
                  academicDegreeId: parseInt(e.target.value),
                });
              }}
              defaultValue={InformationAboutResearcherList?.academicDegreeId}
              showValidationMessage={
                state.InformationAboutResearchersValidate
                  ? state.InformationAboutResearchersValidate.includes(
                      "AcademicDegree"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="RoleInResearch"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setInformationAboutResearcherList({
                  ...InformationAboutResearcherList,
                  roleInResearch: e.target.value,
                });
              }}
              defaultValue={
                state.OneInformationAboutResearchers?.roleInResearch
              }
              showValidationMessage={
                state.InformationAboutResearchersValidate
                  ? state.InformationAboutResearchersValidate.includes(
                      "RoleInResearch"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="NatonalBaseResearcherNmber"
              show={true}
              type={"number"}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setInformationAboutResearcherList({
                  ...InformationAboutResearcherList,
                  natonalBaseResearcherNmber: e.target.value,
                });
              }}
              defaultValue={
                state.OneInformationAboutResearchers?.natonalBaseResearcherNmber
              }
              showValidationMessage={
                state.InformationAboutResearchersValidate
                  ? state.InformationAboutResearchersValidate.includes(
                      "NatonalBaseResearcherNmber"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <div style={{ marginTop: "10px" }}>
              <label>
                مرفق السبرة الذانية
                <span className="star" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <div style={{ marginTop: "20px" }}>
                <AttachmentASFH
                  id={"CVDocumentAttachment"}
                  // text={"انقر لتعديل المرفق"}
                  title={"إضافة مرفق"}
                  disabled={shouldDisableFields}
                  show={shouldDisableFields ? false : true}
                  // show={true}
                  clear={false}
                  AttachementType="CVDocumentAttachment"
                  singleFile={
                    state.OneInformationAboutResearchers?.cvDocumentAttachment
                  }
                  readOnly={false}
                  onChange={(e) => {
                    setFileChange(fileChange + 1);
                    setCVDocumentAttachment(e.target.files[0]);
                    setInformationAboutResearcherList({
                      ...InformationAboutResearcherList,
                      cvDocumentAttachment: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.InformationAboutResearchersValidate
                      ? state.InformationAboutResearchersValidate.includes(
                          "CVDocumentAttachment"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
              </div>
            </div>

            {!shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit" ? UpdateInfo() : AddInfo();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneInformationAboutResearchers} />
    </>
  );
}

export default AddEditInformationAboutResearcher;
